import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const FullScreenLoader = () => (
    <Box
        sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1302,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "background.default",
        }}
    >
        <CircularProgress color="primary" aria-label="Loading" />
    </Box>
);

export default FullScreenLoader;
